import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Button, Typography, notification, Modal } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../AuthContext";
import "../App.css";

const { Title, Text } = Typography;

const PasswordReset = () => {
  const [form] = Form.useForm(); 
  const { userId } = useParams();
  const navigate = useNavigate();


  const userLogin = async (values) => {
    try {
        console.log(values)

      const response = await axios.post(
        `${process.env.REACT_APP_API}/api/auth/reset-password/${userId}`,{password:values.password}
      );
      notification.success({
        message: "Password Update Successful",
      })

      setTimeout(() => {
        navigate("/login");
      }, 0);

    //   console.log(response.data);
    } catch (error) {
      console.error("Sign-in error:", error);
      notification.error({
        message: "Sign-in failed",
        description: "Please try again.",
      });
    }
  };


  return (
    <div className="container">
      <h1 className="title">ZautoAI Leading the AI Revolution</h1>
      <p className="subtitle"> No worries, we'll help you reset it. Just enter your new password below.</p>
      <Form
        form={form}
        onFinish={userLogin}
        className="form"
        layout="vertical"
      >
          <Form.Item
          name="password"
          label="Password"
          rules={[
            { required: true, message: 'Please enter your password' },
          ]}
        >
          <Input type='password' placeholder="Enter your password" />
        </Form.Item>
        <Form.Item
          name="confirmpassword"
          label="Confirm Password"
          rules={[
            { required: true, message: 'Please re enter your password' },
          ]}
        >
          <Input type='password' placeholder="Re enter your password" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className="button">
            Change Password
          </Button>
        </Form.Item>
       </Form>
    </div>
  );
};

export default PasswordReset;
